import React from "react";
import Table from "../../common/Table";
const UpcomingPayments = () => {
  const columns = [
    {
      header: "Invoice No",
      width: 20,
    },
    {
      header: "Invoice Date",
      width: 20,
    },
    {
      header: "Due Date",
      width: 20,
    },
    {
      header: "Ref DO",
      width: 20,
    },
    {
      header: "Status",
      width: 20,
    },
  ];
  return (
    <div className="tb2">
      <div className="flex-between mb1">
        <label>Upcoming Payments</label>
        <span>VIEW ALL</span>
      </div>
      <Table columns={columns} />
    </div>
  );
};

export default UpcomingPayments;
